import jwt_token from "jwt-decode";

export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties
  };
};

export const getStrValue = property => {
  if (null === property) {
    return "";
  }

  return property;
};

export const isA = () => {
  return getRole() === "ADMIN";
};

export const isReporter = () => {
  return getRole() === "REPORTER";
};

export const isCA = () => {
  return getRole() === "CLIENT_ADMIN";
};

export const isRestricted = () => {
  const token = localStorage.getItem("token");
  
  if (!token) {
    return false;
  }
  const t = jwt_token(token);
  
  return t.restricted;
};

const getRole = () => {
  const token = localStorage.getItem("token");
  
  if (!token) {
    return false;
  }
  const t = jwt_token(token);
  return t.role;
};


export const isDiff = (array1, array2) => {
  if (array1 && array2) {
    if (array1.length !== array2.length) {
      return true;
    }
    var shouldUpdate = false;
    for (var i = 0; i < array1.length; i++) {
      if (array2.filter(e => e.email === array1[i].email).length === 0) {
        shouldUpdate = true;
        break;
      }
    }

    return shouldUpdate;
  } else if (!array1 && array2) {
    return true;
  }

  return false;
};



// WEBPACK FOOTER //
// ./src/store/utility.js